import {
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  ActionCreatorWithoutPayload,
  createSlice,
} from '@reduxjs/toolkit';

import { IModalsState } from '@sv-support-sdk/chat-shared-types/src/store/modals';

export const initialState = {
  activeModal: '',
  data: {},
} as IModalsState;

const createModalsSlice = <T extends IModalsState, Reducers extends SliceCaseReducers<T>>({
  name = 'modals',
  initialState,
  reducers,
  resetState,
}: {
  name?: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
  resetState: ActionCreatorWithoutPayload;
}) =>
  createSlice({
    name,
    initialState,
    reducers: {
      setActiveModal: (state, action: { payload: string }) => ({
        ...state,
        activeModal: action.payload,
        data: {},
      }),
      setModalData: (state, action) => ({
        ...state,
        data: action.payload,
      }),
      ...reducers
    },
    extraReducers: (builder) => {
      builder.addCase(resetState, () => {
        return initialState;
      });
    },
  });

export default createModalsSlice;
